import { ref } from '@vue/composition-api'
import { COLUMN_OPERATION, COLUMN_INDEX } from '../_data'
export const useSettings = () => {
  const columnOperation = [...COLUMN_OPERATION]
  const columnsShow = ref(columnOperation.find((item) => item.id === 1))
  const columnsIndex = ref(columnOperation.find((item) => item.id === 2))
  return {
    columnsShow,
    columnsIndex,
    columnIndex: COLUMN_INDEX
  }
}
